import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FeatureType, Grid, ModalSize, MonthlyPlan } from '../../../shared'
import { ActionToolbarButtonsComponent } from '../../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridExportComponent } from '../../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'
import { MonthlyProjectionPlanComponent } from './monthly-plan.component'

@Component({
    templateUrl: './monthly-plans.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class MonthlyProjectionPlansComponent extends BaseComponent {
    grid: Grid<MonthlyPlan>

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.OperationsProjectionsView])
    }

    constructor() {
        super()
        this.grid = new Grid<MonthlyPlan>(this.services).setupModalEditing(
            this.services.data.monthlyPlans,
            'Monthly Plan',
            MonthlyProjectionPlanComponent,
            () => new MonthlyPlan(),
            this,
            ModalSize.small,
        )
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.monthlyPlans.queryAll()).subscribe({
                next: () => {
                    this.initialLoadingComplete()
                    this.grid.items = this.services.data.monthlyPlans.items
                },
            }),
        )
    }
}
